import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";

import { FormGenerator } from "../../../common/commonComponents/formGenerator";
import studentDetails from "../studentForm.json";
import studentEmptyResponse from "../studentDetailsObject.json";
import { Accordion } from "../../../common/commonComponents/Accordion/accordion";
import { fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";
import CustomLoader from "../../../common/commonComponents/Loader/loader";
import { gender, category } from "../constant";

import CustomButton from "components/CustomButton";
import EditTicketInfo from "./EditTicketInfo";
import { DEFAULT_FORM_FIELDS, getLatestDateAmongTwo } from "./helper";
import EditStudentDetails from "./EditStudentDetails";
import { maskEmail } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils";

const StudentInformation = ({ studentId, userPermissions }) => {
  const [isFetching, setFetching] = useState(true);
  const [studentResponse, setStudentDetails] = useState({});
  const [studentContactResponse, setStudentContactDetails] = useState({});
  const [studentParentDetails, setStudentParentDetails] = useState({});

  const [studentDetailsResponse, setStudentDetailsResponse] = useState({});
  const [contactDetailsResponse, setContactDetailsResponse] = useState({});
  const [parentDetailsResponse, setParentDetailsResponse] = useState({});

  const [isOpenTicketDialog, setIsOpenTicketDialog] = useState(false);
  const [ticketDetails, setTicketDetails] = useState(DEFAULT_FORM_FIELDS);

  const [isEditingAllowed, setIsEditingAllowed] = useState(false);

  const formatStudentResponse = (response) => {
    const studentMobileNumber = formatMobileNumber(
      response?.studentMobileNumber
    );
    const whatsappNumber = formatMobileNumber(response?.whatsappNumber);
    const primaryMobileNumber = formatMobileNumber(
      response?.primaryMobileNumber
    );
    const studentEmailId = formatEmail(response?.studentEmailId);
    const studentGcId = maskEmail(response?.studentGcId);
    const dob = formatDate(response?.dob);
    const studGender = gender[response?.gender]
      ? gender[response?.gender]
      : response?.gender;
    const studentCategory = category[response?.studentCategory]
      ? category[response?.studentCategory]
      : response?.studentCategory;
    const bloodGroup =
      response?.bloodGroup == "U" ? "Unknown" : response?.bloodGroup;
    return {
      ...response,
      dob: dob,
      bloodGroup: bloodGroup,
      studentCategory: studentCategory,
      gender: studGender,
      studentMobileNumber: studentMobileNumber,
      whatsappNumber: whatsappNumber,
      primaryMobileNumber: primaryMobileNumber,
      studentEmailId: studentEmailId,
      studentGcId,
    };
  };

  const formatAddressResponse = (response) => {
    const activeHomeContact = response?.studentAddressDetailDTOList.filter(
      (item) => {
        return item.addressType == "HOME" && item.status == "ACTIVE";
      }
    );
    const sortedAddresses = activeHomeContact.sort(
      (a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate)
    );
    const contact = sortedAddresses[0];
    const fatherEmailDetail = response?.studentEmailDetailDTOList.find(
      (item) => item.communicationType == "Email" && item.contactType == "HOME"
    );
    const motherEmailDetail = response?.studentEmailDetailDTOList.find(
      (item) => item.communicationType == "Email" && item.contactType == "OTHR"
    );
    const fatherPhoneNumberDetail = response?.studentPhoneDetailDTOList.find(
      (item) => (item.communicationType = "Phone" && item.contactType == "HOME")
    );
    const motherMobileNumberDetail = response?.studentPhoneDetailDTOList.find(
      (item) => (item.communicationType = "Phone" && item.contactType == "CELL")
    );
    const studentParentDetails = {
      studentFathersEmailId: formatEmail(fatherEmailDetail?.contactValue),
      studentMothersEmailId: formatEmail(motherEmailDetail?.contactValue),
      studentFathersMobileNumber: formatMobileNumber(
        fatherPhoneNumberDetail?.contactValue
      ),
      studentMothersMobileNumber: formatMobileNumber(
        motherMobileNumberDetail?.contactValue
      ),
    };

    const unmaskedParentsContact = {
      fathersEmailId: fatherEmailDetail?.contactValue,
      mothersEmailId: motherEmailDetail?.contactValue,
      fathersMobileNumber: fatherPhoneNumberDetail?.contactValue,
      mothersMobileNumber: motherMobileNumberDetail?.contactValue,
    };

    return { contact, studentParentDetails, unmaskedParentsContact };
  };

  const getStudentDetails = async () => {
    // const response = await fetchAllPromisedData(
    //     `${endpoint.studentDetails.getStudentsInfo}/${studentId}`,
    //     true
    // );
    const response = await fetchAllPromisedData(
      `${endpoint.studentDetails.getStudentPersonalInfo}/${studentId}`,
      true
    );

    if (response.code == 200) {
      setStudentDetails(formatStudentResponse(response.data));
      setStudentDetailsResponse({ ...response.data, psid: studentId });
      setParentDetailsResponse((prev) => ({
        ...prev,
        ...response.data,
        ...getLatestDateAmongTwo(prev, response.data),
      }));
      setContactDetailsResponse((prev) => ({
        ...prev,
        ...response.data,
        ...getLatestDateAmongTwo(prev, response.data),
      }));

      setFetching(false);
    } else {
      setFetching(false);
    }
  };
  const getContactDetails = async () => {
    // const response = await fetchAllPromisedData(
    //     `${endpoint.studentDetails.getStudentsInfo}/${studentId}`,
    //     true
    // );
    const response = await fetchAllPromisedData(
      `${endpoint.studentDetails.getStudentContactDetails}/${studentId}`,
      true
    );

    if (response.code == 200) {
      const { contact, studentParentDetails, unmaskedParentsContact } =
        formatAddressResponse(response?.data);
      setStudentContactDetails(contact);
      setStudentParentDetails(studentParentDetails);
      setContactDetailsResponse((prev) => ({
        ...prev,
        ...contact,
        ...getLatestDateAmongTwo(prev, contact),
      }));
      setParentDetailsResponse((prev) => ({
        ...prev,
        ...response.data,
        ...unmaskedParentsContact,
        ...getLatestDateAmongTwo(prev, contact),
      }));
      setFetching(false);
    } else {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (studentId) {
      getStudentDetails();
      getContactDetails();
    }
  }, [studentId]);

  const formatMobileNumber = (phoneNumber) => {
    if (phoneNumber && phoneNumber.trim()) {
      return phoneNumber.length >= 4
        ? "+91 " +
            "*".repeat(phoneNumber.length - 4) +
            phoneNumber.substring(phoneNumber.length - 4)
        : "+91" + phoneNumber;
    }
    return null;
  };
  const formatEmail = (email) => {
    if (email && email.trim()) {
      const atIndex = email.indexOf("@");
      const username = email.slice(0, atIndex);
      const domain = email.slice(atIndex + 1);
      const beforeEmail =
        username.length >= 3
          ? "*".repeat(username.length - 3) + username.slice(-3)
          : username;
      const afterEmail =
        domain.length >= 5
          ? "*".repeat(domain.length - 5) + domain.slice(-5)
          : domain;
      const transformedEmail = beforeEmail + "@" + afterEmail;
      return transformedEmail;
    }
    return null;
  };
  const formatDate = (responseDate) => {
    const date = new Date(responseDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };
  // const formatGender=(responseGender)=>{
  //   if(responseGender=="M")
  //   return "Male";
  //   if(responseGender=="F")
  //   return "Female";
  //   if(responseGender=="U")
  //   return "Unknown";
  // }

  const closeTicketDialog = () => {
    setIsOpenTicketDialog(false);
  };
  const resetTicketDialog = () => {
    setTicketDetails(DEFAULT_FORM_FIELDS);
  };

  const saveTicketInfo = () => {
    setIsEditingAllowed(true);
    closeTicketDialog();
  };

  const exitEditMode = () => {
    setIsEditingAllowed(false);
    resetTicketDialog();
  };

  const saveStudentDetails = (response) => {
    setStudentDetails(formatStudentResponse(response));
    setStudentDetailsResponse({ ...response, psid: studentId });
  };

  const saveContactDetails = (api1Response, api2Response) => {
    setStudentDetails(formatStudentResponse(api1Response));
    const { contact, studentParentDetails } =
      formatAddressResponse(api2Response);
    setStudentContactDetails(contact);
    setStudentParentDetails(studentParentDetails);

    const latestAudit = getLatestDateAmongTwo(api1Response, contact);
    setContactDetailsResponse({
      ...api1Response,
      ...contact,
      ...latestAudit,
    });
  };

  const saveGuardianDetails = (api1Response, api2Response) => {
    setStudentDetails(formatStudentResponse(api1Response));
    const { contact, studentParentDetails, unmaskedParentsContact } =
      formatAddressResponse(api2Response);
    setStudentContactDetails(contact);
    setStudentParentDetails(studentParentDetails);

    const latestAudit = getLatestDateAmongTwo(api1Response, contact);
    setParentDetailsResponse({
      ...api1Response,
      ...api2Response,
      ...unmaskedParentsContact,
      ...latestAudit,
    });
  };

  if (isEditingAllowed)
    return (
      <>
        <EditStudentDetails
          ticketDetails={ticketDetails}
          exitEditMode={exitEditMode}
          changeTicketDetails={() => setIsOpenTicketDialog(true)}
          studentDetailsResponse={studentDetailsResponse}
          contactDetailsResponse={contactDetailsResponse}
          parentDetailsResponse={parentDetailsResponse}
          saveStudentDetails={saveStudentDetails}
          saveContactDetails={saveContactDetails}
          saveGuardianDetails={saveGuardianDetails}
        />

        {isOpenTicketDialog && (
          <EditTicketInfo
            ticketDetails={ticketDetails}
            setTicketDetails={setTicketDetails}
            closeTicketDialog={closeTicketDialog}
            saveTicketInfo={saveTicketInfo}
          />
        )}
      </>
    );

  return isFetching ? (
    <div className="col">
      <CustomLoader apiLoader={isFetching} />
    </div>
  ) : (
    <div className="student-details-info-tab">
      {/* // HIDE EDIT STUDENT DETAILS
       <div className="mb-4 d-flex justify-content-end">
        <CustomButton
          content={"Edit Information"}
          permissionType={"U"}
          icon={true}
          forTable={true}
          onClick={() => {
            setIsOpenTicketDialog(true);
          }}
          permissionSet={userPermissions}
          className="px-2 text-bold"
        />
      </div> */}
      <Accordion title="Student details">
        <Row className="pt-3">
          <FormGenerator
            fields={Object.keys(studentDetails.studentDetail)}
            fieldsObject={studentDetails.studentDetail}
            // values={studentResponse?.studentDetailsWithMasterDTO ?? studentEmptyResponse.studentDetailsDTO}
            values={{
              ...studentEmptyResponse.studentDetailsDTO,
              ...studentResponse,
            }}
            setValues={() => {}}
            dataObjects={{}}
            readOnly={true}
            col={6}
          />
        </Row>
      </Accordion>

      <Accordion title="Contact details">
        <Row className="pt-3">
          <FormGenerator
            fields={Object.keys(studentDetails.contactDetails)}
            fieldsObject={studentDetails.contactDetails}
            // values={studentResponse?.studentContactDetailsWithMasterResponseDTO ?? studentEmptyResponse.studentContactDetailsWithMasterResponseDTO}
            values={{
              ...studentEmptyResponse.studentContactDetailsWithMasterResponseDTO,
              ...studentResponse,
              ...studentContactResponse,
            }}
            setValues={() => {}}
            dataObjects={{}}
            readOnly={true}
            col={6}
          />
        </Row>
      </Accordion>

      <Accordion title="Student’s Parent/Guardian Information">
        <Row className="pt-3">
          <FormGenerator
            fields={Object.keys(studentDetails.otherDetails)}
            fieldsObject={studentDetails.otherDetails}
            // values={studentResponse?.studentDetailsWithMasterDTO ?? studentEmptyResponse.studentDetailsDTO}
            values={{
              ...studentEmptyResponse.studentDetailsDTO,
              ...studentResponse,
              ...studentParentDetails,
            }}
            setValues={() => {}}
            dataObjects={{}}
            readOnly={true}
            col={6}
          />
        </Row>
      </Accordion>

      {isOpenTicketDialog && (
        <EditTicketInfo
          ticketDetails={ticketDetails}
          setTicketDetails={setTicketDetails}
          closeTicketDialog={closeTicketDialog}
          saveTicketInfo={saveTicketInfo}
        />
      )}

      {/* <Accordion title="Bank details">
        <Row className="pt-3">
          <FormGenerator
            fields={Object.keys(studentDetails.bankDetails)}
            fieldsObject={studentDetails.bankDetails}
            values={
              studentResponse?.studentBankDetailsWithMasterDto ??
              studentEmptyResponse.studentBankDetailsWithMasterDto
            }
            setValues={() => {}}
            dataObjects={{}}
            readOnly={true}
            col={6}
          />
        </Row>
      </Accordion> */}
    </div>
  );
};

export default StudentInformation;
